import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext  } from "react";
import SVG from 'react-inlinesvg';

const ConstituencyResultMap = ({state="पश्चिम बंगाल"}) => {
    const masterconfig = useContext(MasterConfigContext);
    const widgetKey = masterconfig?.["assembly_widgets_2026"]?.["mapWidget"];
    const mapWidgetYear =widgetKey?.["year"]||"2021";
      if(!widgetKey || !state){
        return null;
      }
    const selectTally = () => {
        return widgetKey[state];
      };
  
    const tallyUrl =selectTally()
  
    return (
      <div className="bg-gray-100 mx-4 md:mx-2 p-4 rounded-lg my-4  ">
        <div className="flex gap-1 items-center">
          <div className="w-8 h-8">
            <SVG src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/location.svg"} className="w-6 h-6"/>
          </div>
          <h2 className="text-md font-semibold mb-2 -ml-2 mt-1">
            {`${state} विधानसभा चुनाव सीटवार नतीजे ${mapWidgetYear}`}
          </h2>
        </div>
        <iframe
          frameborder="0"
          scrolling="no"
          mozallowfullscreen=""
          height={650}
          src={tallyUrl}
          webkitallowfullscreen=""
          width="100%"
          className="min-h-[400px]  sm:h-[610px] md:h-[590px]"
        ></iframe>
      </div>
    )
}

export default ConstituencyResultMap